import { render, staticRenderFns } from "./OriginalScript.vue?vue&type=template&id=f9b08a2a&scoped=true"
import script from "./OriginalScript.vue?vue&type=script&lang=js"
export * from "./OriginalScript.vue?vue&type=script&lang=js"
import style0 from "./OriginalScript.vue?vue&type=style&index=0&id=f9b08a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b08a2a",
  null
  
)

export default component.exports